<template>
  <div class="documento-dipendente" v-loading="loaderSave">
    <div class="header-tab row row-custom">
      <div class="return col-6">
        <icon name="riv-arrow2" scale="1.2" flip="horizontal"
              @click.native="link('DOCElenco')" class="pointer"></icon>
        <!--<span class="my-label">{{ $t('documentoDip.datiAnag') }}</span>-->
      </div>
      <div class="ordine col-12">
        <div class="magazzino col-24">{{documento.desMag}}</div>
        <div class="numero col-24">{{getOrdNum(documento.numOrd)}}</div>
      </div>
      <div class="fornitore col-6">
        {{fornitore}} - {{desFornitore}}
      </div>
    </div>

    <div class="testata row row-custom">

      <div class="col-24" :style="{ height: '30px'}">
        <div class="row row-custom tipologia">
          <span >
            {{documento.codTipo}} - {{documento.desTipo}}
          </span>
        </div>
      </div>

      <div class="col-lg-12 col-sm-20 col-22" :style="{minHeight: '450px', height: (contenitoreHeight - 80 - 72 - 37) + 'px'}" v-loading="loading_metadati">
        <div class = "metadati" :style="{minHeight: '450px', height: (contenitoreHeight - 80 - 72 - 37) + 'px'}">
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.dipendente') }}
            </div>
            <div class="testata-value col-16 no-padding">
              <span>{{documento.codDip}} - {{documento.desDip}}</span>
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.dtDoc') }}
            </div>
            <!--<div class="testata-value col-16 no-padding" v-if="idDoc === ''">
              <el-date-picker
                v-model="documento.dataDoc" :disabled="disabled"
                type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                placeholder="" class="custom-date-picker"
                :picker-options="{firstDayOfWeek: 1}">
              </el-date-picker>
            </div>
            <div class="testata-value col-16 no-padding" v-else>-->
            <div class="testata-value col-16 no-padding">
              {{ (documento.dataDoc === '' || documento.dataDoc === undefined) ? '' : moment(documento.dataDoc, 'YYYYMMDD').format('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.dtSca') }}
            </div>
            <!--<div class="testata-value col-16 no-padding" v-if="idDoc === ''">
              <el-date-picker
                v-model="documento.dataSca" :disabled="disabled"
                type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                placeholder="" class="custom-date-picker"
                :picker-options="{firstDayOfWeek: 1}">
              </el-date-picker>
            </div>
            <div class="testata-value col-16 no-padding" v-else>-->
            <div class="testata-value col-16 no-padding">
              {{ (documento.dataSca === '' || documento.dataSca === undefined) ? '' : moment(documento.dataSca, 'YYYYMMDD').format('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.stato') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{getStato(documento)}}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.dtApp') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{ (documento.dataApp === '' || documento.dataApp === undefined) ? '' : moment(documento.dataApp, 'YYYYMMDD').format('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.userApp') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{documento.approvatore}}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.idDoc') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{documento.idDoc}}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.dtDoc') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{ (documento.dataIns === '' || documento.dataIns === undefined) ? '' : moment(documento.dataIns, 'YYYYMMDD').format('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="row row-custom elemento">
            <div class="testata-label col-8">
              {{ $t('documentoDip.userUpl') }}
            </div>
            <div class="testata-value col-16 no-padding">
              {{documento.utenteUpload}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-sm-20 col-22" :style="{minHeight: '450px', height: (contenitoreHeight - 80 - 72 - 37) + 'px'}">
      <!--<div class="col-lg-12 col-sm-20 col-22" :style="{ minHeight: '450px', maxHeight: (contenitoreHeight - 80 - 72) + 'px', height: (contenitoreHeight - 45 - 72) + 'px'}">-->
        <div class="row row-custom doc-container">
          <div class="doc" v-if="idDoc === ''">
            <el-upload
              class="avatar-uploader"
              accept=""
              action=""
              :show-file-list="false"
              :on-change="changeUploadList"
              :auto-upload="false"
              >
              <div v-if="imageUrl">
                <img v-if="docType === 'image/jpeg'" :src="imageUrl" class="avatar" :style="{ maxHeight: (contenitoreHeight - 80 - 72 - 42) + 'px'}">
                <img v-else :src="'static/img/anteprima_' + this.codLang + '.png'" class="avatar" :style="{ maxHeight: (contenitoreHeight - 80 - 72 - 42) + 'px'}">
              </div>
              <div class="add" v-else > 
                <icon name="riv-add_2" scale="1.5" flip="horizontal" class="pointer"></icon>
                <div class="el-upload__text">{{ $t('documentoDip.nuovoDoc') }}</div>
              </div>
              
            </el-upload>

          </div>
          <div v-loading="loaderImg" class="previewImg" v-else>
              <img @click="downloadDoc()" :src="imageUrl" :style="{ maxHeight: (contenitoreHeight - 80 - 72 - 42) + 'px'}">
          </div>
        </div>
      </div>
    </div>

    <div class="bottoni col-24">
      <el-button v-if="idDoc === '' && upload" size="small" @click="uploadDoc()" :loading="saveDisabled" class="custom-button" type="primary">
        {{ $t('documentoDip.btn.carica').toUpperCase() }}
      </el-button>
      <el-button v-if="idDoc !== ''" size="small" @click="downloadDoc()" :loading="saveDisabled" class="custom-button" type="primary">
        {{ $t('documentoDip.btn.scarica').toUpperCase() }}
      </el-button>
      <el-button v-if="idDoc !== '' && documento.docRiva === 'Y' && documento.presaVis  === 'N'" size="small" @click="setDoc('P')" :loading="saveDisabled" class="custom-button" type="primary">
        {{ $t('documentoDip.btn.pv').toUpperCase() }}
      </el-button>
    </div>
  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    components: {},
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      },
      prefixApp: {
        type: String
      }
    },
    name: 'Documento',
    filters: {
      formatDate: function (date) {
        if (date !== undefined && date !== '') {
          return date.substr(0, 2) + '/' + date.substr(2, 2) + '/' + date.substr(4, 4)
        } else {
          return '-'
        }
      },
      formatString : function (string) {
        if (string === '' || string === undefined) {
          return '-'
        } else {
          return string
        }
      },
      truncate: function (string) {
        if (string.length > 150) {
          return string.substr(0, 150) + '...'
        } else {
          return string
        }
      }
    },
    i18n: {
      messages: {
        it_IT: {
          documentoDip: {
            datiAnag: 'Dati Anagrafici',
            ordine: 'Ordine N. {num}',
            dipendente: 'Dipendente',
            dtApp: 'Verificato il',
            userApp: 'Verificato da',
            idDoc: 'Id Documento',
            dtDoc: 'Data Documento',
            dtSca: 'Data Scadenza',
            dtUpl: 'Data Caricamento',
            userUpl: 'Utente Caricamento',
            stato: 'Stato Avanzamento',
            docStatus: {
              1: '1 - Documento da approvare',
              2: '2 - Documenti in regola',
              3: '3 - Documenti non in regola',
              4: '4 - Documento non caricato'
            },
            btn: {
              carica: 'Upload',
              scarica: 'Download',
              pv: 'Presa Visione'
            },
            caricamentoOK: 'Operazione eseguita con Successo',
            caricamentoKO: 'Errore di caricamento',
            nuovoDoc: 'Selezionare un documento da caricare'
          }
        },
        fr_FR: {
          documentoDip: {
            datiAnag: 'Données personnelles',
            ordine: 'Commande N. {num}',
            dipendente: 'Employé',
            dtApp: 'Vérifié le',
            userApp: 'Vérifié par',
            idDoc: 'ID du document',
            dtDoc: 'Publié',
            dtSca: 'Date limite',
            dtUpl: 'Date de dépôt',
            userUpl: "Utilisateur de dépôt",
            stato: 'Le progrès',
            docStatus: {
              1: '1 - Document à approuver',
              2: '2 - Document en règle',
              3: '3 - Document non en règle',
              4: '4 - Document non téléchargé'
            },
            btn: {
              carica: 'Upload',
              scarica: 'Download',
              pv: 'Reconnaissance'
            },
            caricamentoOK: 'Opération effectuée avec succès',
            caricamentoKO: 'Erreur de chargement',
            nuovoDoc: 'Sélectionnez un document à télécharger'
          }
        },
        es_ES: {
          documentoDip: {
            datiAnag: 'Información personal',
            ordine: 'Orden N. {num}',
            dipendente: 'Empleado',
            dtApp: 'Cambiado e',
            userApp: 'Cambiado en',
            idDoc: 'ID del documento',
            dtDoc: 'Fecha Emitido',
            dtSca: 'Fecha límite',
            dtUpl: 'Fecha de carga',
            userUpl: 'Usuario de carga',
            stato: 'Progreso',
            docStatus: {
              1: '1 - Documento a aprobar',
              2: '2 - Documentos en orden',
              3: '3 - Documentos no en orden',
              4: '4 - Documento no cargado'
            },
            btn: {
              carica: 'Upload',
              scarica: 'Download',
              pv: 'Reconocimiento'
            },
            caricamentoOK: 'Operación realizada con éxito',
            caricamentoKO: 'Error de carga',
            nuovoDoc: 'Seleccione un documento para cargar'
          }
        },
        de_DE: {
          documentoDip: {
            datiAnag: 'Persönliche Daten',
            ordine: 'Auftrag N. {num}',
            dipendente: 'Mitarbeiter',
            dtApp: 'Geändert am',
            userApp: 'Geprüft von',
            idDoc: 'Dokument Identifikation',
            dtDoc: 'Ausgegeben',
            dtSca: 'Frist',
            dtUpl: 'Datum des Hochladens',
            userUpl: 'Benutzer wird geladen',
            stato: 'Fortschritt',
            docStatus: {
              1: '1 - Zu genehmigendes Dokument',
              2: '2 - Dokumente in Ordnung',
              3: '3 - Dokumente nicht in Ordnung',
              4: '4 - Dokument nicht hochgeladen'
            },
            btn: {
              carica: 'Upload',
              scarica: 'Download',
              pv: 'Wissen'
            },
            caricamentoOK: 'Operation erfolgreich ausgeführt',
            caricamentoKO: 'Ladefehler',
            nuovoDoc: 'Wählen Sie ein Dokument zum Hochladen aus'
          }
        },
        en_GB: {
          documentoDip: {
            datiAnag: 'Personal data',
            ordine: 'Order N. {num}',
            dipendente: 'Employee',
            dtApp: 'Verified on',
            userApp: 'Verified by',
            idDoc: 'Document ID',
            dtDoc: 'Issued',
            dtSca: 'Deadline',
            dtUpl: 'Upload Date',
            userUpl: 'Upload User',
            stato: 'Progress',
            docStatus: {
              1: '1 - Document to be approved',
              2: '2 - Documents in order',
              3: '3 - Documents not in order',
              4: '4 - Document not uploaded'
            },
            btn: {
              carica: 'Upload',
              scarica: 'Download',
              pv: 'Acknowledgment'
            },
            caricamentoOK: 'Operation performed successfully',
            caricamentoKO: 'Loading error',
            nuovoDoc: 'Select a document to upload'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        codLang: sessionStorage.getItem('codLang'),
        codForn: '',
        country: '',
        idDoc: '',
        documento: {},
        documentoRic: {},
        dipendente: {},
        disabled: false,
        fornitore: '',
        desFornitore: '',
        saveDisabled: false,
        loading: false,
        loading_metadati: false,
        loaderImg: false,
        uploadList: [],
        imageUrl: '',
        loadingDoc: false,
        loaderSave: false,
        docType: '',
        route: '',
        upload: false
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    watch: {
    },
    methods: {
      getStato: function (documento) {
        if (documento.statoDoc === '' || documento.statoDoc === undefined) {
          return ''
        } else {
          return this.$i18n.t('documentoDip.docStatus.' + documento.statoDoc)
        }
      },
      link: function (route) {
        this.$router.push({name: this.route})
      },
      resetDati: function () {
        this.$set(this, 'codForn', '')
        this.$set(this, 'country', '')
        this.$set(this, 'idDoc', '')
        this.$set(this, 'documento', {})
        this.$set(this, 'dipendente', {})
        this.$set(this, 'disabled', false)
        this.$set(this, 'fornitore', '')
        this.$set(this, 'desFornitore', '')
        this.$set(this, 'saveDisabled', false)
        this.$set(this, 'loading', false)
        this.$set(this, 'loading_metadati', false)
        this.$set(this, 'loaderImg', false)
        this.$set(this, 'uploadList', [])
        this.$set(this, 'imageUrl', '')
        this.$set(this, 'loadingDoc', false)
        this.$set(this, 'loaderSave', false)
        this.$set(this, 'docType', '')
        this.$set(this, 'route', '')
        this.$set(this, 'documentoRic', {})
        this.$set(this, 'upload', false)
      },
      init: function () {
        if (this.$store.state.GA_Documento.route === 'DIPDipendente') {
          this.$set(this, 'documentoRic', this.$store.state.DIP_Ricerca)
        } else if (this.$store.state.GA_Documento.route === 'DOCElenco') {
          this.$set(this, 'documentoRic', this.$store.state.DOC_Ricerca)
        }
        this.$set(this, 'route', this.$store.state.GA_Documento.route)
        this.$set(this, 'country', this.documentoRic.country)
        this.$set(this, 'codForn', this.documentoRic.codForn)
        this.$set(this, 'documento', {})
        //this.$set(this, 'dipendente', this.$store.state.DIP_Dipendente)
        this.$set(this, 'fornitore', this.documentoRic.fornitore)
        this.$set(this, 'desFornitore', this.documentoRic.desFornitore)
        this.$set(this, 'idDoc', this.$route.params.id === undefined ? '' : this.$route.params.id)
        if (this.idDoc != '') {
          this.loadDocumento(this.idDoc)
          this.previewDocumento(this.idDoc)
        } else {
           this.$set(this, 'documento', this.$store.state.GA_Documento)
        }
      },
      loadDocumento: function (id) {
        this.$set(this, 'loading_metadati', true)
        this.$http.get('accessostabilimenti/documentodip', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn,
          idDoc: id,
          appCode: this.prefixApp.toLowerCase(),
        }
      })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'documento', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading_metadati', false)
          })
      },
      getOrdNum: function (numOrd) {
        if (numOrd === '000000' || numOrd === '') {
          return ''
        } else {
          return this.$i18n.t('documentoDip.ordine', {num: numOrd})
        }
      },
      previewDocumento: function (id) {
        this.$set(this, 'loaderImg', true)
        this.$http.get('accessostabilimenti/preview', {
          params: {
            container: 'RIVFORDOCDIT',
            dKey: id
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'imageUrl', 'data:image/jpeg;base64,' + response.body.data.file)
            } else {
              this.$set(this, 'imageUrl', 'static/img/anteprima_' + this.codLang + '.png')
              /*this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })*/
            }
            this.$set(this, 'loaderImg', false)
          })
      },
      uploadDoc: function () {
        this.$set(this, 'loaderSave', true)

        let formData = new FormData()
        formData.append('fornitore', this.fornitore)
        formData.append('codDip', this.documento.codDip)
        formData.append('codTipo', this.documento.codTipo)
        formData.append('codValidita', this.documento.codValidita === undefined ? '' : this.documento.codValidita)
        formData.append('annoOrd', this.documento.annoOrd)
        formData.append('numOrd', this.documento.numOrd)
        formData.append('codSoc', this.documento.codSoc)
        formData.append('codMag', this.documento.codMag)
        formData.append('dataDoc', '') //this.documento.dataDoc
        formData.append('dataSca', '') //this.documento.dataSca
        formData.append('file', this.uploadList.raw)
        this.$set(this, 'loadingDoc', true)

        this.$http.post('documentirichiesti/uploaddoc', formData, {
          params: {
            codLang: this.codLang,
            codForn: this.codForn,
            country: this.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('documentoDip.caricamentoOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.$set(this, 'loaderSave', false)
              this.link('DOCElenco')
              //this.getDocumenti(this.prodottoSelectedDoc.codProd)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loaderSave', false)
            }
            //this.$set(this, 'uploadList', [])
            //this.$refs.uploadDoc.clearFiles()
            this.$set(this, 'loaderSave', false)
          })
      },
      downloadDoc: function () {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAccessoStabilimenti + 'print/doc?idCli=RIV&idApp=FORDOCDIT' + '&keyDoc=' + this.documento.idDoc + '&quality='+ process.env.qualityCM + '&token=' + response.body.wsToken)
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeUploadList: function (file, fileList) {
        //const isLt2M = file.size / 1024 / 1024 < 2;

        //if (!isLt2M) {
        //  this.$message.error('Avatar picture size can not exceed 2MB!');
        //} else {
          this.$set(this, 'upload', true)
          this.$set(this, 'docType', fileList[fileList.length -1].raw.type)
          this.$set(this, 'uploadList', fileList[fileList.length -1])
          this.$set(this, 'imageUrl', URL.createObjectURL(file.raw))
        //}
      },
      handleExceed: function () {
        this.$message({
          showClose: true,
          message: 'Permesso solo l\'upload di un file alla volta',
          type: 'error',
          duration: process.env.duration
        })
      },
      handleRemove: function (file, fileList) {
        this.$set(this, 'uploadList', fileList)
      },
      setDoc: function(op) {
        this.$set(this, 'loaderSave', true)

        let data = {
          fornitore: this.fornitore,
          idDoc: this.documento.idDoc,
          codDip: this.codDip,
          codTipo: this.documento.codTipo,
          codSoc: this.documento.codSoc,
          codMag: this.documento.codMag,
          annoOrd: this.documento.annoOrd,
          numOrd: this.documento.numOrd,
          op: op
        }

        this.$http.post('accessostabilimenti/setdoc', data, {
          params: {
            codLang: this.codLang,
            country: this.country,
            codForn: this.codForn,
            appCode: this.prefixApp.toLowerCase()
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.loadDocumento(this.idDoc)
              this.$set(this, 'loaderSave', false)
              //this.getDocumenti(this.prodottoSelectedDoc.codProd)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg.msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loaderSave', false)
            }
          })
      }

       /*,
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('Avatar picture must be JPG format!');
        }
        if (!isLt2M) {
          this.$message.error('Avatar picture size can not exceed 2MB!');
        }
        return isJPG && isLt2M;
      } */
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";


  @media only screen and (max-width: 875px) and (min-width: 776px) {
    .modal-documenti {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 550px;
            .el-upload-list {
              width: 400px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 775px) {
    .modal-documenti {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 400px;
            .el-upload-list {
              width: 250px;
            }
          }
        }
      }
    }
  }
  .documento-dipendente {
    height: auto;
    .header-tab {
      padding-top: 12px;
      height: 80px;
      text-align: center;
      .return {
        padding-left: 15px;
        .fa-icon {
          margin-top: 5px;
          line-height: 30px;
          float: left;
        }
        span {
          float: left;
          text-transform: uppercase;
          line-height: 30px;
          height: 30px;
          .set-font(@color: @oroRiva; @size: 16px; @family: 'os-semibolditalic');
        }
      }
      .ordine {
        .magazzino {
          height: 20px;
          .set-font(@size: 14px; @color: @greenRiva; @family: 'os-semibolditalic');
          text-transform: uppercase;
        }
        .numero {
          height: 40px;
          .set-font(@size: 16px; @color: @oroRiva; @family: 'os-semibolditalic');
          text-transform: uppercase;
        }
      }
      .fornitore {
        .set-font(@color: @greenRiva; @size: 16px; @family: 'os-semibolditalic');
        text-align: right;
      }
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');

      }
      .sotto-label {
        .set-font(@size: 15px; @family: 'os-lightitalic');
        height: 25px;
      }
    }
    .testata {
      //margin-top: 20px;
      .elemento-grande {
        margin-bottom: 0px !important;
      }
      .tipologia {
        line-height: 30px;
        .set-font(@color: @oroRiva; @size: 16px; @family: 'os-semibolditalic');
        display: block;
        text-align: center;
        padding-bottom: 10px;
      }
      .metadati {
        background-color: #edecea;
        //margin-left: 20px;
        //margin-right: 20px;
        border-top: 1px solid @oroRiva;
        padding-top: 30px;
        .elemento {
          height: 21px;
          margin-bottom: 20px;
          .testata-label {
            .set-font(@size: 11px; @color: @greenRiva; @family: 'os-semibold');
            text-align: right;
            line-height: 20px;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .testata-doppia {
            .my-label {
              margin-bottom: 5px;
              line-height: 20px;
            }
          }
          .testata-value {
            .set-font(@size: 12px; @color: @textTable; @family: 'os-regular');
            text-transform: uppercase;
            .el-input__inner {
              font-size: 12px;
              letter-spacing: 1px;
            }
            .el-date-editor {
              width: 150px;
            }
          }
        }
      }
      .doc-container {
        //padding-top: 40px;
        height: 100%;
        .doc {
          height: 100%;
          width: 100%;
          border: 1px solid @grayMedium;
          border-style: dashed;
          .el-upload {
            display:block;
            margin:auto;
          }
          .add {
            margin-top: 4px;
            line-height: 30px;
            color: #bb515c;
          }
        }
        .previewImg {
          height: 100%;
          width: 100%;
          border: 1px solid @grayMedium;
          border-style: dashed;
          img {
              display: block;
              margin-left: auto;
              margin-right: auto;
            }
        }
      }
    }
    .separatore {
      border-top: 1px solid #e7e7e7;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    
    .bottoni {
      margin-top: 30px;
      margin-bottom: 10px;
      text-align: right;
    }
  
    .return-tab {
      padding-left: 15px;
      padding-bottom: 15px;
      .fa-icon {
        margin-top: 5px;
        line-height: 30px;
        float: left;
      }
      span {
        float: left;
        text-transform: uppercase;
        line-height: 30px;
        height: 30px;
        padding-left: 15px;
        .set-font(@color: @greenRiva; @size: 16px; @family: 'os-semibolditalic');
      }
      .capitalize {
        text-transform: capitalize;
        padding-left: 5px;
      }
    }
    .titoloTab {
      margin-bottom: 15px;
      span {
        .set-font(@size: 14px; @color: @rossoRiva; @family: 'os-semibolditalic');
        text-transform: capitalize;
        line-height: 30px;
        font-weight: normal;
        //border-bottom: 1px solid #bb515c;
        display: block;
        text-align: center;
      }
    }
    .custom-tabs {
      &.el-tabs {
        .el-tabs__header {
          .counter-nuovi {
            .el-badge {
              .el-badge__content {
                height: 18px;
                width: 18px;
                top: 9px;
                right: -3px;
                padding: 0;
                line-height: 16px;
                .set-font(@color: @white, @size: 10px);
                letter-spacing: 0;
                background-color: @oroRiva;
              }
            }
          }
          .el-tabs__item {
            width: 250px;
            font-size: 14px;
            text-transform: capitalize;
          }
        }
      }
    }

    .custom-table {
      .el-table__header {
        thead {
          th {
            .cell {
              font-size: 13px;
            }
          }
        }
      }
      .action{
        .fa-icon {
          color: @rossoRiva
        }
      }
    }
  }
  /*.el-select-dropdown {
    &.rightSelect {
      text-align: right;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/Documento.vue